<!--<div-->
<!--    id="active-lesson-slide-container">-->
<!--    <app-slide-preview></app-slide-preview>-->
<!--</div>-->

<div #activeElement id="active-element">
  @if (isConnectedToCall$|async) {
    <div
      id="active-lesson-slide-container">
      <app-slide-preview></app-slide-preview>
    </div>
  }
</div>


@if (callWithChatProps$|async; as callWithChatProps) {
  <div>
    <div renderReact [reactComponent]="App" [props]="callWithChatProps"></div>
    <!--    <div renderReact [reactComponent]="CallWithChatExperience" [props]="callWithChatProps"></div>-->
    <!-- {{ callWithChatProps|json }}-->
  </div>
}

